<template>
  <div class="index">
    <div class="header" :class="isFromCCRCWindow ? 'qiankunheader' : ''" >
      <img src="https://ccrc-biz-public.oss-cn-hangzhou.aliyuncs.com/web/datva/nav-img.png"
           alt=""
           width="100%"
           height="220px">
      <div class="btn" >
        <div class="back-btn" >
          <el-button
            v-if="isFromCCRCWindow"
            class="logout"
            size="mini"
            @click="backHome"
            type="danger"
            >返回</el-button>
        </div>
      </div>     
      <div class="logo">
        <span>{{$website.name}}</span>
        <small>{{$website.subName}}</small>
      </div>
      <navs @change="handleChange"></navs>
    </div>
    <div class="main">
      <router-view />
    </div>
  </div>
</template>
<script>
import { getList } from '@/api/glob'
import navs from './nav/index'
export default {
  name: "index",
  components: {
    navs,
  },
  data () {
    return {
      isFromCCRCWindow:window.isFromCCRCWindow ? true :false,
      publicPath: process.env.VUE_APP_PATH,
    }
  },
  created () {
    this.initGlob();
  },
  mounted () {
    if (this.$website.isDemo) {
      // this.$notify({
      //   dangerouslyUseHTMLString: true,
      //   title: 'Avue-Data大屏-完整源码版',
      //   message: `点击购买`,
      //   duration: 0,
      //   onClick: () => {
      //     window.open('https://avuejs.com/views/pay/')
      //   }
      // });
    }
  },
  methods: {
    backHome(){
      if(process.env.NODE_ENV === "development"){
        window.location.assign("http://localhost:5000/systemview");
      }else{
        window.location.assign("https://test.lcchunyi.com/systemview");
      }
    },
    initGlob () {
      getList({
        current: 1,
        size: 100,
      }).then(res => {
        let list = res.data.data.records
        list.forEach(ele => {
          window.$glob[ele.globalKey] = ele.globalValue
        })
      })
    },
    handleChange (item, index) {
      this.$router.push({ path: item.path })
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/list.scss";
.index {
  height: 100%;
  .header {
    position: relative;
    .nav {
      margin: 0 20px;
      width: 100%;
      position: absolute;
      bottom: 10px;
      border: none;
      .el-menu-item {
        background-color: rgba(0, 0, 0, 0) !important;
      }
    }
  }
  .qiankunheader{
    .logo {
      position: absolute;
      top: 30px;
      left: 90px;
    }
    .btn{
      position: absolute;
      top: 50px;
      left: 20px;
    }
  }
  .main {
    width: 100%;
    height: calc(100% - 220px);
  }
  .content {
    overflow-x: hidden;
  }
  .logo {
    position: absolute;
    top: 30px;
    left: 20px;
  }
}
</style>